/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ProgressTrackerStore } from 'src/core/stores/ProgressTrackerStore';

export type AddTrackerParameters = {
    /**
     * The tracker to use to track the transaction.
     */
    tracker?: ProgressTrackerStore;
};

/**
 * Creates a decorator that attaches a progress tracker to enable
 * the caller component to keep track of the call that was made.
 *
 * @param progressTracker The tracker to use to track transaction.
 */
export const addTracker = (input: AddTrackerParameters) => async (transaction: Promise<void>): Promise<void> => {
    if (!input) {
        return transaction;
    }

    const { tracker } = input;

    if (!tracker) {
        return transaction;
    }

    try {
        tracker.setState('running');
        await transaction;
        tracker.setState('completed');
    } catch (error) {
        tracker.setState('failed', <Error>error);

        throw error;
    }
};
